import {RingsProps} from './Rings.types';

import * as css from './Rings.css';

/**
 * The `Rings` component renders an animated set of telescoping rings. It is
 * frequently used to add visual emphasis when showing the users TallyAge™, and
 * may be absolutely positioned behind the age in the UI.
 */
export const Rings = ({variant = 'shrink', ...otherProps}: RingsProps) => (
  <div {...otherProps}>
    <div className={css.root({variant})}>
      <div className={css.ring0({variant})} />
      <div className={css.ring1({variant})} />
      <div className={css.ring2({variant})} />
      <div className={css.ring3({variant})} />
      <div className={css.ring4({variant})} />

      {variant === 'double' && (
        <>
          <div className={css.ring5} />
          <div className={css.ring6} />
        </>
      )}
    </div>
  </div>
);
